import { render, staticRenderFns } from "./EmvClearing.vue?vue&type=template&id=162fa1bf&"
import script from "./EmvClearing.vue?vue&type=script&lang=js&"
export * from "./EmvClearing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports